module.exports = __webpack_public_path__ + "img/inn4.28fa2482.jpg";